import { useEffect, useMemo, useState } from "react";
import { PiHouseLineBold, PiListChecksBold } from "react-icons/pi";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Scrollbars } from "rc-scrollbars";

// import images
import Logo from "./../../assets/images/logo.png";
import Collapse from "./../../assets/images/hamburger.png";
import { PiSignOut } from "react-icons/pi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const SideBar = () => {
  const location = useLocation();
  const [collapseMenu, setCollapseMenu] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const { company_master_account } = useSelector((state) => state.auth);

  const invitationURL = useMemo(
    () => `https://${company_master_account?.checkin_url}/login`,
    [company_master_account?.checkin_url],
  );

  useEffect(() => {
    if (company_master_account && !company_master_account.checkin_url) {
      toast.error(
        "Your employee platform URL hasn't been configured yet. Please contact SupportRoom to set it up.",
        { toastId: "no-checkin-url" },
      );
    }
  }, [company_master_account]);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(invitationURL)
      .then(() => {
        console.log("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div className="vh-100 position-relative">
      <div className="d-flex w-100 align-items-center justify-content-between py-4 my-lg-3 d-lg-flex d-none">
        {!collapseMenu && (
          <Link to="/" className="ps-3">
            <img src={Logo} alt="logo" />
          </Link>
        )}
        <Link
          className="ps-3"
          to="#"
          onClick={(e) => {
            e.preventDefault();
            setCollapseMenu(!collapseMenu);
          }}
        >
          <img src={Collapse} alt="hamburger" />
        </Link>
      </div>

      <Scrollbars
        autoHide
        autoHeight
        autoHeightMax="calc(100vh - 215px)"
        renderThumbVertical={({ style, ...props }) => (
          <div
            {...props}
            style={{
              ...style,
              backgroundColor: "#CCC", // Change color
              borderRadius: "4px",
            }}
          />
        )}
      >
        <Sidebar
          className="border-0"
          rootStyles={{
            "& .ps-sidebar-container, &.ps-submenu-content": {
              backgroundColor: "transparent !important",
              color: "#CCC",
              fontSize: "1rem",
            },
            "& .ps-sidebar-root": {
              border: "none !important", // This removes the border
            },
            "&.ps-collapsed": {
              width: "50px",
              minWidth: "50px",
              "& .ps-submenu-content .ps-menu-button": {
                paddingLeft: "30px !important",
                paddingRight: "10px",
              },
            },
          }}
          breakPoint="sm"
          collapsed={isMobile || collapseMenu}
        >
          <Menu
            menuItemStyles={{
              button: {
                [`&.ps-active, &:hover`]: {
                  background:
                    "linear-gradient(90.01deg, rgba(0, 200, 160, 0.4) 0.01%, rgba(0, 200, 160, 0) 52.67%)",
                  color: "#FFF",
                },
              },
            }}
          >
            <MenuItem
              icon={<PiHouseLineBold />}
              active={
                location.pathname.startsWith("/dashboard") ||
                location.pathname.startsWith("/insights")
              }
              component={<Link to="/dashboard" />}
            >
              Dashboard
            </MenuItem>
            <MenuItem
              icon={<PiListChecksBold />}
              active={location.pathname.startsWith("/questions")}
              component={<Link to="/questions" />}
            >
              Check-in Questions
            </MenuItem>
            <MenuItem
              icon={<PiSignOut />}
              active={location.pathname === "/logout"}
              component={<Link to="/logout" />}
            >
              Logout
            </MenuItem>
          </Menu>
        </Sidebar>
      </Scrollbars>

      {!collapseMenu && !isMobile && company_master_account?.checkin_url && (
        <div className="px-4 py-4 position-absolute bottom-0 side-menu-copy-button-container">
          <p className="text-light fw-semibold mb-0">
            Invite users to join platform
          </p>
          <p className="text-white text-truncate mb-1">{invitationURL}</p>
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={copyToClipboard}
          >
            Copy URL
          </button>
        </div>
      )}
    </div>
  );
};

export default SideBar;
